exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.img-card[data-v-6761b450] {\n    position: relative;\n    margin-bottom: 10px;\n}\n.icon-delete[data-v-6761b450] {\n    position: absolute;\n    top: 5px;\n    right: 5px;\n    cursor: pointer;\n    color: #ff4d4f;\n}\n", ""]);

// exports
